import "babel-polyfill"
import React from 'react';
import {Provider} from 'react-redux';
import {render} from 'react-dom';
import {AppRoute} from './app/routes/Routes';
import {ConfigureStore} from './app/store/ConfigureStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import './public/assets/styles/main.css';
import './public/assets/styles/style.css';
import 'react-toastify/dist/ReactToastify.css';
import {getToken} from "./utils/TokenManager";
import { setUserData } from './actions/AuthAction';
import 'react-table/react-table.css'
import './public/assets/styles/custom.css';

const store = ConfigureStore();

const token = getToken();
if (typeof token !== 'undefined' && token !== 'undefined' && token) {
    store.dispatch(setUserData(token));
}

render(
    <Provider store={store}>
        <AppRoute/>
    </Provider>
    , document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js